function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "77.25 72.3 473.8 473.415",
  width: "2500",
  height: "2500"
}, props), React.createElement("mask", {
  id: "a"
}, React.createElement("path", {
  d: "M314.152 72.307L550.856 309.01 314.152 545.715 77.448 309.01z",
  fill: "#fff"
}), React.createElement("path", {
  d: "M159.65 293.55H267.8l46.35-51.5 51.5 51.5H473.8L314.15 121.03l-154.5 172.52z"
})), React.createElement("path", {
  d: "M314.152 72.307L550.856 309.01 314.152 545.715 77.448 309.01z",
  mask: "url(#a)"
})));